/**
* Sorting functions for results step 1
* Results List
*/

import { logger, dId, dQSa, showError, showPopUp, removePopUp } from "./utils";
import { redrawDivs, drawcargridNode } from "./result_render";
import { hide_loader, start_tick } from "./loader_ticker";
import { call_results, enable_search, filterRes } from "./results_functions";
import { reservaD, json_response, vehiculoAry, setVehicleAry, json_fecha, json_vehicle } from "./variables";
import { ajax_alternative_offices } from "./ajax";
import { langDict } from "./dict";

declare const FILTER_VEHICLE: number;

/** Check how many results have been returned
 * If still under max, then show loading panel
 * If equal to max, load the mixed results
 * If over max and no results, show try again message
 */
function checkZeroes(results_returned: number, provCt: number, noResCt: number) {

	// !on rentoauto, need to check for revendor hidden results. 
	const cgn_vis = dQSa(".af-car-grid").length;

	logger("Zero Check: " + results_returned + " / " + provCt + " / " + noResCt, "log");

	if (results_returned > provCt && noResCt > provCt) {

		logger("No results: show try again", "error");
		checkAlternativeOffices();
		hide_loader();
		enable_search();

	} else if (cgn_vis <= 0 && noResCt > provCt) {

		logger("No visible results: show try again", "error");
		checkAlternativeOffices();
		hide_loader();
		enable_search();

		logger("No res - after mixed", "warn");

	} else if (results_returned > provCt) {

		hide_loader();
		enable_search();
	
		logger("Have results - request ended", "log");

		/* Added 2019-04 - mixed results last filter */
	} else if (results_returned == provCt) {

		call_results(true);
		start_tick();
	
	}

}


function sortResults(json: any) {

	// TODO: type vehiculoAry

	logger("sort results ...");
	
	let veL = 0;
	let viL = 0;
	let vehExt: json_vehicle[] = [];
	let vehInt: json_vehicle[] = [];
	let vehNew: json_vehicle[] = [];

	if (json.hasOwnProperty("vehiculosExternos")) {
		vehExt = json.vehiculosExternos as json_vehicle[];
	}

	if (json.hasOwnProperty("vehiculosInternos")) {
		vehInt = json["vehiculosInternos"] as json_vehicle[];
	}

	if (json.hasOwnProperty("dates")) {

		logger("Set SQL dates from results","log");
		const fecha = json["dates"] as json_fecha;
		reservaD[5] = fecha.compudays;
		reservaD[9] = fecha.sqldesde;
		reservaD[10] = fecha.sqlhasta;
	}

	vehNew = [...vehInt, ...vehExt];

	// If there were no results (although format is good) - Then tally: 
	if (vehNew.length <= 0) {
		logger("provided empty list of results","warn");
		return false;
 	}

	// add array to global array:
	setVehicleAry(vehNew);

	// Sort global array by price: 
	vehiculoAry.sort(function (a, b) {

		// May not have oneway value: 
		if ( a.cuotaoneway  === undefined || a.cuotaoneway === null) { a.cuotaoneway = 0; }
		if ( b.cuotaoneway  === undefined || b.cuotaoneway === null) { b.cuotaoneway = 0; }

		let priceA = (a.cu*reservaD[5] + a.cuotaoneway*1);
		let priceB = (b.cu*reservaD[5] + b.cuotaoneway*1);
		let compare = Math.floor(priceA - priceB);

		return ( compare );

	});

	return true;

}

/** Render results onto screen */
function showResults() {

	logger("show results for " + vehiculoAry.length + " vehicles", "log");
	

	// if mobile, scroll to results starting: 
	let scroll_loc = (<HTMLElement>dId("resGrid")).offsetTop - document.body.scrollTop;

	if (document.body.clientWidth > 600 && (<HTMLElement>dId("filterGrid")) !== null) {
		scroll_loc = (<HTMLElement>dId("filterGrid")).offsetTop - document.body.scrollTop;
	}

	document.body.scrollTop = scroll_loc;

	let html = "";

	for (var i = 0; i < vehiculoAry.length; i++) {
		html += drawcargridNode( vehiculoAry[i], i)
	}

	redrawDivs(1);
	(<HTMLElement>dId("resGrid")).innerHTML = html;
	check_lazyload_results();


	// If this is a 9pax search, then set filter to show only minivans: 
	if (FILTER_VEHICLE>0) {
		if (reservaD[84]==0) {
		logger("Results are filtered to group ("	+ FILTER_VEHICLE + ")", "warn");
		filterRes(FILTER_VEHICLE);
		} else {
			logger("Results are no longer filtered to group", "warn");
		}
	}

}


// 2020-08 alternative offices. Popup box and listener for buttons
function checkAlternativeOffices() {

	// If one-way then dont show alternative search as it updates both offices: 
	if (reservaD[8] == "1") {
		showPopUp(langDict[70]);
		return;
	}

	logger("check alternative offices");

	const data = {
		prov: reservaD[15], 
		ciudad: reservaD[12],
		dia: reservaD[1],
		hora: reservaD[2],
		tipo: reservaD[7]
	};

	ajax_alternative_offices(data)
	.then((json) => {

		let res: json_response = (json as json_response);

		if (res.status !== "" && res.status !== "error" && res.result !== null) {

			let newSearch = langDict[71];  // span opens in dictionary
			let resalt = res.result?.length ?? 0;

			for (let i = 0; i < resalt; i++) {
				newSearch += `<div class='office-alternative'>
				${res.result[i]}<br><button class='btn' data-destino='${res.result[i]}'>${langDict[72]}</button></div>`;
			}

			newSearch += "</span>";

			if (resalt > 0) {

				showPopUp(newSearch);

				// Add listener to new search buttons:
				const newSearchBtns = dQSa(".office-alternative button");

				newSearchBtns.forEach((elem) => {

					elem.addEventListener("click", (e) => {

						removePopUp();

						if (e.target) {

							const src = <HTMLInputElement>e.target;

							if (src.dataset.destino === undefined) {
								return;
							}

							(<HTMLInputElement>dId("oficina_salida_selector")).value = src.dataset.destino + " (" + reservaD[6] + ")";
							(<HTMLInputElement>dId("f_ciudad")).value = src.dataset.destino;
							(<HTMLInputElement>dId("sel_misma_oficina")).checked = false;

							reservaD[12] = src.dataset.destino;
							reservaD[16] = "1000";
							reservaD[8] = "0";

							call_results(false);

						}
					});
				});

			} else {
				showPopUp(langDict[70]);
			}

		} else {
			showPopUp(langDict[70]);
		}

	})
	.catch((err) => {
		showError(langDict[73]);
	});

}


/**
 * Adds animation listeners to each result on resGrid.
 */
function check_lazyload_results() {
	
  let lazyloadResImages = dQSa(".drivein-img");  
 
	const imageObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				var image = entry.target;
				image.classList.remove("drivein-img");
				image.classList.add("drivein-img-parked");
				imageObserver.unobserve(image);
			}
		});
	});

	lazyloadResImages.forEach(function(image) {
		imageObserver.observe(image);
	});
    

}



export { checkZeroes, sortResults, showResults, checkAlternativeOffices };
